import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/** 목차·성적서 검토 창이 같이 쓰는 서류 상태 색. */
export const DOC_STATUS_COLOR = {
  valid: '#2EA2DE',
  substitute: '#7B61FF',
  performance: '#1976d2',
  expired: '#DB4E2E',
  missing: '#DBDBDB',
};

const ITEMS = [
  { label: '성적서', color: DOC_STATUS_COLOR.valid },
  { label: '대체성적서', color: DOC_STATUS_COLOR.substitute },
  { label: '성능확인서', color: DOC_STATUS_COLOR.performance },
  { label: '만료', color: DOC_STATUS_COLOR.expired },
  { label: '없음', color: DOC_STATUS_COLOR.missing },
];

/** 대체성적서 아이콘. 만료면 빨강, 그 외는 보라. */
export const substituteIconColor = (isValid) => (
  isValid === false ? DOC_STATUS_COLOR.expired : DOC_STATUS_COLOR.substitute
);

const DocumentStatusLegend = () => (
  <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
    {ITEMS.map((item) => (
      <Stack key={item.label} direction="row" spacing={0.5} alignItems="center">
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: item.color,
            border: item.color === DOC_STATUS_COLOR.missing ? '1px solid #BDBDBD' : 'none',
            flexShrink: 0,
          }}
        />
        <Typography variant="caption" color="text.secondary">
          {item.label}
        </Typography>
      </Stack>
    ))}
  </Stack>
);

export default DocumentStatusLegend;
